// TODO: Handle ENPS logon too

import { Injectable } from '@angular/core';
//import { AppService } from '../../../app.service';
//import { ServiceResponse } from "../../../data/models/service/service-response";
import { IAuthService } from '../iauth.service';

@Injectable()
export class ENPSService /* implements IAuthService */ {
    /*constructor(public appService: AppService) { }

    public async authenticate(): Promise<ServiceResponse<void>> {
        return await this.loginWithToken();
    }

    public async loginWithToken(): Promise<ServiceResponse<void>> {
        let userNameChunks = [];
        let domain = '';
        let userNameToSend = this.appService.username;
        if (this.appService.username.indexOf('@') != -1) {
            userNameChunks = this.appService.username.split('@');
            userNameToSend = userNameChunks[0];
            domain = userNameChunks[1];
        } else if (this.appService.username.indexOf('\\') != -1) {
            userNameChunks = this.appService.username.split('\\');
            userNameToSend = userNameChunks[1];
            domain = userNameChunks[0];
        }

        return await this.appService.EnpsServiceProvider.logon(userNameToSend, this.appService.password, "", domain);
    }

    public logout() {
        console.log("Logged out.");
    }*/
}



// WEBPACK FOOTER //
// ./src/app/providers/authentication/enps/enps.service.ts